//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/SelectCurveList.js";
import "../Motion/Motion.SelectFlexBody.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CloseCurve",1,0],[1,"Curves",0,"SelectCurveList",0],[0,"DefinitionMethod",1,0],[1,"FlexBody",0,"Motion.SelectFlexBody",0],[1,"Tolerance",0,"Expression",0]],[[["index"],"InsertEmptyNode",{},1,0],[["index","nodeLabel"],"AssignNode",{},2,0],[["index","point"],"AssignNodeFromPoint",{},2,0],[["index"],"RemoveNode",{},1,0],[[],"RemoveAllNodes",{},0,0],[["index1","index2"],"SwapNodes",{},2,0],[[],"FindNodesFromCurves",{},0,0]],[]];
SPLM.Motion.FlexCurveBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.FlexCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.FlexCurveBuilder.DefinitionMethodType = Object.freeze({
    "Nodes" : "Nodes", "Points" : "Points", "ExistingCurves" : "ExistingCurves"});

export default SPLM;